import { SECTION_OPTIONS } from "./constants";

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getLocalISODate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const ADMIN_MAX_DATE_RANGE_DAYS = 60;

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const getAdminMaxSelectableDate = (baseDate = new Date()) =>
  addDays(baseDate, ADMIN_MAX_DATE_RANGE_DAYS - 1);

export const getAdminMaxRangeEndDate = (startDate) =>
  addDays(startDate, ADMIN_MAX_DATE_RANGE_DAYS - 1);

export const formatDateWithTimezone = (dateStr, tz = "Asia/Kolkata") => {
  if (!dateStr) return null;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return typeof dateStr === "string" && dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(d);
    let year, month, day;
    parts.forEach(part => {
      if (part.type === 'year') year = part.value;
      if (part.type === 'month') month = part.value;
      if (part.type === 'day') day = part.value;
    });
    return `${year}-${month}-${day}`;
  } catch (e) {
    return typeof dateStr === "string" && dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
  }
};

export const formatAdminDisplayDate = (dateValue, tz = "Asia/Kolkata") => {
  if (!dateValue) return "—";
  if (dateValue === "permanent") return "Permanent";

  let isoDate = dateValue;
  if (typeof dateValue === "string" && dateValue.includes("T")) {
    isoDate = formatDateWithTimezone(dateValue, tz) || dateValue.split("T")[0];
  }

  const [year, month, day] = String(isoDate).split("-");
  if (!year || !month || !day) return String(dateValue);
  return `${day}-${month}-${year}`;
};

export const overlaps = (first, second) => {
  const firstRight = first.x + first.width - 1;
  const secondRight = second.x + second.width - 1;
  const firstBottom = first.y + first.height - 1;
  const secondBottom = second.y + second.height - 1;
  return !(
    firstRight < second.x ||
    secondRight < first.x ||
    firstBottom < second.y ||
    secondBottom < first.y
  );
};

export const findOpenPosition = (sections, office, shape) => {
  for (let y = 1; y <= office.gridRows - shape.height + 1; y += 1) {
    for (let x = 1; x <= office.gridColumns - shape.width + 1; x += 1) {
      const candidate = { x, y, width: shape.width, height: shape.height };
      const hasConflict = sections.some((section) => overlaps(candidate, section));
      if (!hasConflict) return { x, y };
    }
  }
  return null;
};

export const getSectionShape = (type) =>
  SECTION_OPTIONS.find((option) => option.value === type) || SECTION_OPTIONS[0];

export { OFFICE_THEMES } from "./constants";

export const getSeatLimitBySectionType = (type) => {
  if (type === "cabin") return 1;
  if (type === "cubicle") return 6;
  if (type === "conference") return 8;
  return 12;
};

export const getSeatColumnsBySectionType = (type) => {
  if (type === "cabin") return 1;
  if (type === "cubicle") return 3;
  if (type === "conference") return 4;
  return 6;
};

export const generateDateRange = (startDate, endDate) => {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);
  while (current <= end) {
    const day = current.getDay();
    if (day !== 0 && day !== 6) {
      dates.push(getLocalISODate(current));
    }
    current.setDate(current.getDate() + 1);
  }
  return dates;
};

export const generateRecurringDates = (startDate, endDate, weekdays) => {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);
  const daySet = new Set(weekdays);
  while (current <= end) {
    const day = current.getDay();
    if (day !== 0 && day !== 6 && daySet.has(day)) {
      dates.push(getLocalISODate(current));
    }
    current.setDate(current.getDate() + 1);
  }
  return dates;
};
